var Router = function() {
	var _t = this;

	var state = '';
	var routes = [];

	Object.defineProperty(this, 'path', {
		get: function() {
			return location.search.substr(1);
		},
		set: function(path) {
			this.navigate('?' + path);
		}
	});

	var updateRoute = function(route) {
		var newQuery = routes
			.filter(function(r) { return r.toString(); }) // hides empties
			.map(function(r) { return r.toString(); })
			.join('/')
		;

		state = newQuery;
	};

	var route = function(query) {
		state = query;
		routes.forEach(function(route) {
			route.open(state);
		});
	};

	this.navigate = function(path, e, force) {
		if (path) {
			path = path;
			history.pushState(path, path, path);
		}
		var query = location.search.substr(1);
		route(query);
	};

	this.register = function(route) {
		routes.unshift(route);
		on(route, 'set').then(function() {updateRoute(route); });
	};

	window.onpopstate = function(e) {
		_t.navigate(null, e);
	};
};

module.exports = new Router();
